import { JSX, splitProps, Show } from 'solid-js';
import { Text } from './text';

interface InputProps extends JSX.InputHTMLAttributes<HTMLInputElement> {
    error?: string;
    label?: string;
    // Drops the inline padding and the opaque fill, for an input that sits
    // inside a box already providing both. Overriding them from the call site
    // instead would pit one utility against another and resolve on stylesheet
    // source order rather than on intent.
    bare?: boolean;
}

export const Input = (props: InputProps) => {
    const [local, others] = splitProps(props, ['class', 'error', 'label', 'bare']);

    const boxClasses = local.bare ? 'bg-transparent' : 'px-3 bg-background';

    const baseClasses = `w-full py-1 text-sm ${boxClasses} text-foreground placeholder-muted-foreground focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed`;

    const errorClasses = local.error ? 'border-red' : '';

    const classes = `${baseClasses} ${errorClasses} ${local.class || ''}`;

    return (
        <label class={local.label ? 'flex items-center justify-between gap-2' : 'contents'}>
            <Show when={local.label}>
                <Text tone='muted'>{local.label}</Text>
            </Show>
            <input class={classes} step='any' {...others} />
        </label>
    );
};
